import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Col,
  Row,
  Spin,
  Upload,
  VertButton,
  VertContainer,
  VertTypography,
  message,
} from '@vertem-core/vertice-ds';

import SpotDifal from './spotDifal';
import { SpotButtons } from './spotButtons';
import { useNavigate } from 'react-router';

import { useDispatch, useSelector } from 'react-redux';
import GeneratePDFTerm from './GeneratePDFTerm';
import { useMediaQuery } from 'react-responsive';
import { InboxOutlined, UploadOutlined } from '@ant-design/icons';
import redemptionsApiClient from 'Services/Apis/Spot/redemptionsClient';
import { setTermUrl } from 'redux/Reducers/Spot/spotAproveRedemption';
import Dragger from 'antd/es/upload/Dragger';
import ynToBool from 'Utils/ynToBool';

const SpotTerms = ({
  spot,
  callModalDocuments,
  productsIds,
  termDownloadUrl,
  isLoading,
  isPMO,
  participantId,
  callModal,
  isLead,
  quote,
}) => {
  const userProfile = useSelector((state) => state.oidc.user.profile);
  const userInfos = useSelector(({ oidc: data }) => data);

  const {
    user: { profile, access_token },
  } = userInfos;
  const username = profile.username || profile['custom:login'];

  const config = {
    campaignId: userProfile['custom:campaign_id'],
    catalogId: userProfile['custom:catalog_id'],
    participantId: userProfile['custom:participant_id'],
    Authorization: `Bearer ${access_token}`,
    username: username,
  };

  const navigate = useNavigate();
  const {
    createPDF,
    isLoadingPDF,
    productsPDF: products,
  } = useSelector((state) => state.SpotAproveRedemption);
  const mediaQuery = useMediaQuery({ maxWidth: 767 });
  const dispatch = useDispatch();
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const currentParticipantId = userProfile['custom:participant_id'];

  const uploadQuote = async () => {
    const formData = new FormData();

    setUploading(true);

    fileList.forEach((file) => {
      formData.append('file', file);
    });

    try {
      const response = await redemptionsApiClient.post(
        '/RedemptionFile/Upload',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            ...config,
          },
        }
      );
      dispatch(setTermUrl(response.data.url));
      message.success('Termo foi enviado com sucesso!');
    } catch (err) {
      console.log('uploadQuote err ::: ', err);
    } finally {
      setUploading(false);
    }
  };

  function isSpotPermissionUpdate() {
    const isAccessParticipantToEdit =
      currentParticipantId == String(spot.participantId) &&
      spot.sendToOperation;
    return (
      (spot.type === 1 || spot.type === 2) &&
      !(spot.redemptionStatusId === 5 || spot.redemptionStatusId === 6) &&
      (isPMO || isAccessParticipantToEdit)
    );
  }

  const isLeaderShipConfirmSpotHierarchy =
    isLead && spot.redemptionStatusId === 10;

  return (
    <>
      {isLoading || isLoadingPDF ? (
        <Spin />
      ) : (spot !== null &&
          (spot.type === 1 || spot.type === 2) &&
          ((isPMO && spot.redemptionStatusId === 2) ||
            (spot.redemptionStatusId === 4 && isPMO))) ||
        (participantId == spot.participantId &&
          spot.redemptionStatusId === 4) ||
        isLeaderShipConfirmSpotHierarchy ? (
        <>
          <VertContainer className="container-button-view-redemption">
            <Row justify="center" className="row-button">
              <VertTypography.Paragraph className="title-terms-aprovation">
                Para dar continuidade, essa solicitação precisa de sua
                aprovação. O que deseja fazer?
              </VertTypography.Paragraph>
            </Row>
            {spot.redemptionStatusId === 4 && isPMO && spot.type !== 4 && (
              <>
                <Row justify="center" className="row-button" gutter={[16, 16]}>
                  <Col xs={24} sm={12} md={8} lg={6}>
                    <div className="title-terms-aprovation">
                      {mediaQuery && (
                        <VertButton
                          type="default"
                          className="button-view-redemption"
                          onClick={() => {
                            if (mediaQuery) {
                              callModalDocuments(2, termDownloadUrl);
                            }
                          }}
                        >
                          Enviar Termo
                        </VertButton>
                      )}
                      {!mediaQuery && (
                        <a
                          href={termDownloadUrl}
                          className="title-terms-aprovation"
                          target="_blank"
                        >
                          <VertButton
                            type="default"
                            className="button-view-redemption"
                          >
                            Baixar Termo
                          </VertButton>
                        </a>
                      )}
                    </div>
                  </Col>
                </Row>

                <Row justify="center" gutter={[16, 16]} verticalSpacing="small">
                  <VertTypography.Paragraph className="title-terms-aprovation">
                    Insira o termo de solicitação/aprovação do participante.
                  </VertTypography.Paragraph>
                  <Col xs={24} sm={12} md={8} lg={6}>
                    {mediaQuery && (
                      <Upload
                        customRequest={uploadQuote}
                        maxCount={1}
                        fileList={fileList}
                        listType="picture"
                        onRemove={(file) => {
                          const index = fileList.indexOf(file);
                          const newFileList = fileList.slice();
                          newFileList.splice(index, 1);
                          setFileList(newFileList);
                        }}
                        beforeUpload={(file) => {
                          setFileList([file]);
                          return true;
                        }}
                        style={{
                          width: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      >
                        <VertButton
                          type="default"
                          icon={<UploadOutlined />}
                          block
                          loading={uploading}
                        >
                          {uploading
                            ? 'Enviando termo...'
                            : 'Clique para enviar termo'}
                        </VertButton>
                      </Upload>
                    )}

                    {!mediaQuery && (
                      <Dragger
                        customRequest={uploadQuote}
                        maxCount={1}
                        fileList={fileList}
                        listType="picture"
                        onRemove={(file) => {
                          const index = fileList.indexOf(file);
                          const newFileList = fileList.slice();
                          newFileList.splice(index, 1);
                          setFileList(newFileList);
                        }}
                        beforeUpload={(file) => {
                          setFileList([file]);
                          return true;
                        }}
                      >
                        <p className="ant-upload-drag-icon">
                          <UploadOutlined size={128} />
                        </p>
                        <VertTypography.Text className="ant-upload-hint">
                          Clique ou arraste o arquivo para esta área para enviar
                          o termo.
                        </VertTypography.Text>
                      </Dragger>
                    )}
                  </Col>
                </Row>
              </>
            )}
            {isLeaderShipConfirmSpotHierarchy && (
              <Row justify="center" className="row-button" gutter={[16, 16]}>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <a
                    href={termDownloadUrl}
                    className="title-terms-aprovation"
                    target="_blank"
                  >
                    <VertButton
                      type="default"
                      className="button-view-redemption"
                    >
                      Baixar Termo
                    </VertButton>
                  </a>
                </Col>
              </Row>
            )}

            <SpotButtons
              productsIds={productsIds}
              participantId={participantId}
              callModal={callModal}
              isPMO={isPMO}
              spot={spot}
              isLoading={isLoading}
            />
          </VertContainer>
        </>
      ) : isPMO &&
        spot.redemptionStatusId === 5 &&
        spot.type !== 4 &&
        spot.sendToOperation ? (
        <Row justify="center" className="row-button" gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Button
              type="default"
              danger
              className="button-view-redemption-danger"
              loading={isLoading}
              onClick={() => callModal('reopen')}
              disabled={isLoading}
            >
              {!isLoading && 'Reabrir Solicitação'}
            </Button>
          </Col>
        </Row>
      ) : (
        spot !== null &&
        isLead &&
        (spot.type === 1 || spot.type === 2) &&
        spot.redemptionStatusId === 3 && (
          <VertContainer className="container-button-view-redemption">
            <Row justify="center" gutter={[16, 16]} verticalSpacing="regular">
              <VertTypography.Paragraph className="title-terms-aprovation">
                Para dar continuidade, essa solicitação precisa de sua
                aprovação. O que deseja fazer?
              </VertTypography.Paragraph>
              <Col xs={24} sm={12} md={8} lg={6}>
                <Button
                  type="default"
                  danger
                  loading={isLoading}
                  onClick={() => callModal('cancel')}
                  className="button-view-redemption-danger"
                >
                  Cancelar Solicitação
                </Button>
              </Col>

              {isLoadingPDF ? (
                <>Carregando...</>
              ) : (
                <>
                  {spot && quote && products && createPDF !== null && (
                    <GeneratePDFTerm
                      spot={spot}
                      data={createPDF}
                      headers={config}
                      quote={quote}
                      products={products}
                      isLoading={isLoading}
                    />
                  )}
                </>
              )}
            </Row>
          </VertContainer>
        )
      )}
      {isSpotPermissionUpdate() && (
        <Row
          justify="center"
          className="row-button"
          verticalSpacing="regular"
          gutter={[16, 16]}
        >
          <VertTypography.Paragraph className="title-terms-aprovation">
            Gostaria de editar essa solicitação?
          </VertTypography.Paragraph>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Button
              type="default"
              loading={isLoading}
              onClick={() => {
                navigate(`/edit-redemption/${spot.id}`);
              }}
              className="button-view-redemption-danger"
            >
              Editar Solicitação
            </Button>
          </Col>
        </Row>
      )}
      <Row
        justify="center"
        className="row-button"
        verticalSpacing="regular"
        gutter={[16, 16]}
      >
        <Col xs={24} sm={12} md={8} lg={6}>
          <VertButton
            type="default"
            className="button-view-redemption"
            loading={isLoading}
            onClick={() => navigate('/list-redemptions')}
          >
            Ver Solicitações
          </VertButton>
        </Col>
      </Row>
    </>
  );
};

export default SpotTerms;

SpotTerms.propTypes = {
  spot: PropTypes.object.isRequired,
};
